import React from "react";
import RoleGuard from "@/components/RoleGuard";

/**
 * @deprecated Use `<RoleGuard mode="admin">` diretamente.
 */
const ProtectedAdminRoute = React.forwardRef<HTMLDivElement, { children: React.ReactNode }>(
  ({ children }, _ref) => <RoleGuard mode="admin">{children}</RoleGuard>
);

ProtectedAdminRoute.displayName = "ProtectedAdminRoute";

export default ProtectedAdminRoute;
